// ── Dock Builder ─────────────────────────────────────────────────────────────────────────────
// Its own tool (it used to be the Docks card inside Slip Inventory): draw a marina's docks over
// the imagery -- walkways, fingers, piles, fittings -- and get catalog components, rule checks and
// a bill of materials as you draw (docks-mode.js; the generator and parts catalog are shared with
// the 3D space, services/ais-api/src/docks/).
//
// It works on the same marina and map as Slip Inventory and reads its slips (for "Fingers from
// slips"), through the slip runtime's dockHost: the active project picks the marina, and starting a
// slip draw tool stops a dock tool and vice versa. The runtime is looked up on every call, not
// captured, since closing Slip Inventory replaces it.

import { createDocksMode } from "./docks-mode.js";
import { getSlipInventoryRuntime } from "../slip-delivery/index.js";

let shared = null;

function getDockBuilder(app) {
  if (shared) return shared;
  const host = () => getSlipInventoryRuntime(app).dockHost;
  let panelEl = null, hooked = null, unhook = [];
  const render = () => { if (!panelEl) return; dm.sync(); dm.mountPanel(panelEl.querySelector("[data-dock-builder]")); };
  const dm = createDocksMode({
    app, map: app.map.instance,
    getMarinaId: () => host().getMarinaId(),
    getSlipRings: () => host().getSlipRings(),
    stopOtherTools: () => host().stopSlipTools(),
    isOtherToolActive: () => host().isSlipToolActive(),
    requestRender: render,
  });
  // (re)subscribe to the current slip runtime: its marina changes and its draw tools starting
  const hook = () => {
    const h = host();
    if (hooked === h) return;
    for (const off of unhook) off();
    unhook = [h.onSlipToolStart(() => dm.stopTool()), h.onMarinaChange(() => render())];
    hooked = h;
  };
  const onProject = () => setTimeout(render); // after the slip runtime has taken the new marina
  document.addEventListener("hydrotools:project-changed", onProject);
  shared = {
    mount(el) {
      panelEl = el;
      el.innerHTML = `<div data-dock-builder style="padding:2px 0"></div>`;
      hook(); host().attach(); dm.setActive(true); render();
    },
    unmount() { dm.setActive(false); if (panelEl) panelEl.innerHTML = ""; panelEl = null; },
  };
  return shared;
}

export const dockBuilderTool = {
  id: "dock-builder",
  name: "Dock Builder",
  init(app) { this._db = getDockBuilder(app); },
  destroy() { this._db?.unmount(); this._db = null; },
  renderPanel(app, el) {
    if (!this._db) this._db = getDockBuilder(app);
    this._db.mount(el);
  },
};
